import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
    useMemo,
} from 'react';
import { useNotification } from '../../contexts/NotificationsContext';
import useEncodedUrlId from '../../customHooks/useEncodedUrlId';
import {
    BEDROOM_IMAGE_TYPE_KEY,
    DESCRIPTION_DEATIL_INITIAL_STATE,
    getForwardProgress,
    getIsDifferentContactInfo,
    getVisibleDescription,
    getChildrenAgeSegmentSortOrder,
    HOTELS_LIST_URL,
    IMAGES_DETAIL_INITIAL_STATE,
    NOTE_DETAIL_INITIAL_STATE,
    PROGRESS_INITIAL_STATE,
    PROPERTY_INITIAL_STATE,
    ROOM_INITIAL_STATE,
    supplierHotelViewModelModel,
    supplierRoomViewModelModel,
    URL_ID_KEY,
    VALIDATIONERRORS_INITIAL_STATE,
} from '../../utils/property/propertyUtils';
import endpoints from '../../utils/commonVariables/endpoints';
import api from '../../services/api';
import { savableEntities } from '../../utils/commonVariables/entityKeys';
import {
    ComplementaryDataState,
    ComplementaryChildrenAgeSegmentState,
    ComplementaryImageTypeState,
    ChildrenAgeSegmentState,
    DescriptionDetailState,
    DescriptionState,
    HostSegmentState,
    ImagesDetailState,
    ImageState,
    NoteDetailState,
    NoteState,
    PresentationTabNames,
    PROGRESS_MAIN_INFORMATION_TAB,
    PROGRESS_PUBLIC_PORTRAIT_TAB,
    PROGRESS_ROOM_CONFIGURATION_TAB,
    PROGRESS_STEP,
    ProgressState,
    PropertyState,
    RoomState,
    ServiceState,
    ValidationErrorsState,
    ZinantisServiceState,
} from '../../types/properties/propertyTypes';
import {
    adaptDDBBAttributeDefinitionToState,
    adaptDDBBAttributeValuesAndCreateNewOnesToState,
    adaptDDBBToProgressState,
    adaptDDBBToPropertyState,
    adaptPropertyStateToDDBB,
    adaptRoomDDBBToState,
    adaptRoomToDDBB,
} from '../../services/properties/singlePropertyAdapter';
import { useHistory } from 'react-router-dom';
import useDataAssistant from '../../customHooks/useDataAssistant';
import PROMPT_KEYS from '../../utils/commonVariables/promptKeys';
import convertToOvariant from '../../utils/convertToOvariant';
import { validateForm } from '../../utils/validateForms';
import {
    getBedTypes,
    getChildrenAgeSegments,
    getCities,
    getCountries,
    getCurrencies,
    getDescriptionLanguages,
    getHostSegments,
    getHotelCategories,
    getHotelChains,
    getHotelTypes,
    getImageTypes,
    getMealPlanTypes,
    getProvinces,
    getRegions,
    getRoomServiceCategories,
    getRoomServiceTypes,
    getServiceAttributeDefinitions,
    getServiceCategories,
    getServiceTypes,
    getTimezones,
} from '../../services/properties/propertyComplementaryData';
import { FeedbackMessages } from '../../utils/commonVariables/messages';
import useLanguage from '../../customHooks/useLanguage';

type PropertyCollectionActionType = 'add' | 'update' | 'delete';

interface PropertyContextType {
    isFetching: boolean;
    handleFetching: (_bool?: boolean) => void;
    property: PropertyState;
    isDifferentContactInfo: boolean;
    handleIsDifferentContactInfo: (bool: boolean) => void;
    handleInputChange: (name: string, value: string | number | boolean) => void;
    updateChildrenAgeSegmentAge: (key: string, age: number) => void;
    addChildrenAgeSegment: (
        segment: ComplementaryChildrenAgeSegmentState,
        age: number
    ) => void;
    deleteChildrenAgeSegment: (key: string) => void;
    handleResetLocation: () => void;
    progress: ProgressState;
    handleForwardProgress: (step: PROGRESS_STEP) => ProgressState;
    deleteStateRoom: (id: string) => void;
    handleProgress: (
        step?: PROGRESS_STEP | '',
        tab?: { title: string; tabNumber: number }
    ) => void;
    complementaryData: ComplementaryDataState;
    getMainInfoSectionData: () => Promise<void>;
    getDescriptionSectionData: () => Promise<void>;
    toggleItemInCollection: (
        collectionKey: 'services' | 'hostSegments',
        targetItem: ServiceState | HostSegmentState
    ) => void;
    modidyCollectionItem: (
        collectionKey: 'descriptions' | 'notes',
        action: PropertyCollectionActionType,
        item: DescriptionState | NoteState | { id: string }
    ) => void;
    descriptionDetail: DescriptionDetailState;
    handleDescriptionDetailChange: (
        newValue: Partial<DescriptionDetailState>
    ) => void;
    getAIDescription: (lang: string) => Promise<void>;
    isLoadingAIDescriptionAssistant: boolean;
    AIDescriptionAnswer: string;
    AIDescriptionError: string;
    resetAIDescriptionAssistant: () => void;
    noteDetail: NoteDetailState;
    handleNoteDetailChange: (newValue: Partial<NoteDetailState>) => void;
    imagesDetail: ImagesDetailState;
    togglePanelOpen: (bool: boolean) => void;
    setImagesDetailCategory: (
        category: ComplementaryImageTypeState | null
    ) => void;
    setAddRoomImageDetail: () => void;
    setAddImageDetail: (category: ComplementaryImageTypeState | null) => void;
    resetImageDatailData: () => void;
    addImagesToDetail: (images: ImageState[]) => void;
    deleteImagesFromDetail: (id?: string) => void;
    handleSaveDDBBMainInfo: (newProgress?: ProgressState) => Promise<void>;
    handleSaveFinish: () => Promise<void>;
    handleSaveRoomsToDDBB: () => Promise<void>;
    getRoomsSectionData: () => Promise<void>;
    roomDetail: string;
    handleTargetRoom: (id: string) => void;
    handleRoomInputChange: (name: string, value: string | number) => void;
    toggleRoomItemInCollection: (
        collectionKey: 'services',
        targetItem: ServiceState
    ) => void;
    handleIsValidated: (bool: boolean) => void;
    isValidated: boolean;
    propertyValidationErrors: ValidationErrorsState;
    handleValidation: (errors: Partial<ValidationErrorsState>) => void;
    toggleFeaturedImage: (id: string, bool: boolean) => void;
    toggleImage360: (id: string) => void;
    handleDeleteImage: (id: string) => Promise<void>;
    saveDetailImagesToDDBB: () => Promise<void>;
    toggleRoomImageIs360: (idImg: string) => void;
    toggleRoomImageFeature: (idImg: string) => void;
    addNewRoom: (room: RoomState) => void;
    handleRoomDescription: (
        action: PropertyCollectionActionType,
        newRoomDescription: DescriptionState
    ) => void;
    // zitoneo
    presentationSelectedTab: PresentationTabNames;
    changePresentationTab: (newValue: PresentationTabNames) => void;
    getZitoneoServicesData: () => Promise<void>;
    addNewZitoneoService: (
        zitoneoService: ZinantisServiceState
    ) => Promise<void>;
    toggleZitoneoService: (
        zitoneoService: ZinantisServiceState
    ) => Promise<void>;
    visibleIdServicesDetail: number;
    handleToggleVisibleServicesDetail: (idServiceType?: number) => void;
    handleChangeZitoneoServiceValue: (
        id: string,
        value: string | boolean | Date | number | null,
        idService: string,
        idAttributeDefinition: number
    ) => void;
    handleRemoveZitoneoServiceValue: (
        id: string,
        idService: string,
        idAttributeDefinition: number
    ) => void;
    handlePropertyAttributeValueChange: (
        id: string,
        idAttributeDefinition: number,
        value: string | boolean | Date | number | null
    ) => void;
    handleDeleteHotelAttributeValue: (
        id: string,
        idAttributeDefinition: number
    ) => void;
}

const PropertyContext = createContext<PropertyContextType | undefined>(
    undefined
);

export const PropertyProvider = ({ children }: { children: ReactNode }) => {
    const history = useHistory();
    const { setErrorMessage, setSuccessMessage } = useNotification();
    const idSupplierHotel = useEncodedUrlId(URL_ID_KEY);
    const [isFetching, setIsFetching] = useState(false);
    const [property, setProperty] = useState<PropertyState>(
        PROPERTY_INITIAL_STATE
    );
    const [progress, setProgress] = useState<ProgressState>(
        PROGRESS_INITIAL_STATE
    );

    const [isDifferentContactInfo, setIsDifferentContactInfo] = useState(false);
    const handleIsDifferentContactInfo = (bool: boolean) => {
        setIsDifferentContactInfo(bool);
    };

    const handleFetching = (fetching?: boolean) => {
        setIsFetching(prev => {
            if (fetching === undefined) {
                return !prev;
            }
            return fetching;
        });
    };

    const handleProgress = (
        step?: PROGRESS_STEP | '',
        tab?: { title: string; tabNumber: number }
    ) => {
        setProgress(prev => {
            if (!step || !tab) {
                return {
                    ...prev,
                    activeStep: '',
                    activeTab: 0,
                    activeTabKey: '',
                };
            }
            return {
                ...prev,
                activeStep: step,
                activeTab: tab.tabNumber,
                activeTabKey: tab.title as
                    | PROGRESS_MAIN_INFORMATION_TAB
                    | PROGRESS_PUBLIC_PORTRAIT_TAB
                    | PROGRESS_ROOM_CONFIGURATION_TAB,
                progressByStep: {
                    ...prev.progressByStep,
                    [step]: {
                        ...prev.progressByStep[step],
                    },
                },
            };
        });
    };

    const handleForwardProgress = () => {
        if (progress.totalProgress === 100) return progress;
        const newProgress = getForwardProgress(progress);
        setProgress(newProgress);
        return newProgress;
    };

    useEffect(() => {
        const isValidNumber = !isNaN(Number(idSupplierHotel));
        if (!isValidNumber || !idSupplierHotel) return;
        getHotelData(idSupplierHotel);
    }, [idSupplierHotel]);

    const getHotelData = async (id: string) => {
        try {
            setIsFetching(true);
            const endpoint = endpoints.viewModel(
                savableEntities.SupplierHotel,
                id
            );
            const { data } = await api.post(
                endpoint,
                supplierHotelViewModelModel
            );

            // error handling
            if (!data.Success && data.Messages && data.Messages.length) {
                setErrorMessage(data.Messages[0]?.Title);
                history.push(HOTELS_LIST_URL);
                return;
            }
            const stateProperty = adaptDDBBToPropertyState(data.Result);
            setProperty(stateProperty);
            // if the booking and accounting email/phone have not been set, we assume that the contact info is the same as the general email/phone
            setIsDifferentContactInfo(getIsDifferentContactInfo(stateProperty));
            setProgress(prev => {
                return { ...prev, ...adaptDDBBToProgressState(data.Result) };
            });
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        } finally {
            setIsFetching(false);
        }
    };

    const handleInputChange = (
        name: string,
        value: string | number | boolean
    ) => {
        setProperty(prev => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    const updateChildrenAgeSegmentAge = (key: string, age: number) => {
        setProperty(prev => ({
            ...prev,
            childrenAgeSegments: prev.childrenAgeSegments.map(segment =>
                segment.key === key && !segment.Deleted
                    ? { ...segment, age, __isChanged: true }
                    : segment
            ),
        }));
    };

    const addChildrenAgeSegment = (
        segment: ComplementaryChildrenAgeSegmentState,
        age: number
    ) => {
        setProperty(prev => {
            const deletedSegment = prev.childrenAgeSegments.find(
                current => current.key === segment.key && current.Deleted
            );
            if (deletedSegment) {
                return {
                    ...prev,
                    childrenAgeSegments: prev.childrenAgeSegments.map(current =>
                        current === deletedSegment
                            ? {
                                  ...current,
                                  age,
                                  Deleted: false,
                                  __isChanged: true,
                              }
                            : current
                    ),
                };
            }

            const newSegment: ChildrenAgeSegmentState = {
                ...segment,
                age,
                __isAdded: true,
            };
            return {
                ...prev,
                childrenAgeSegments: [...prev.childrenAgeSegments, newSegment],
            };
        });
    };

    const deleteChildrenAgeSegment = (key: string) => {
        setProperty(prev => {
            const target = prev.childrenAgeSegments.find(
                segment => segment.key === key && !segment.Deleted
            );
            if (!target) return prev;

            return {
                ...prev,
                childrenAgeSegments: target.__isAdded
                    ? prev.childrenAgeSegments.filter(
                          segment => segment.key !== key
                      )
                    : prev.childrenAgeSegments.map(segment =>
                          segment.key === key
                              ? {
                                    ...segment,
                                    Deleted: true,
                                    __isChanged: true,
                                }
                              : segment
                      ),
            };
        });
    };

    const toggleItemInCollection = (
        collectionKey: 'services' | 'hostSegments',
        targetItem: ServiceState | HostSegmentState
    ) => {
        // simple collections => segments, services...
        setProperty(prev => {
            const itemExists = prev[collectionKey].some(
                item => item.id === targetItem.id
            );

            if (itemExists) {
                // if the item exists, handle with deleted true/false
                return {
                    ...prev,
                    [collectionKey]: prev[collectionKey].map(item => {
                        if (item.id === targetItem.id) {
                            return {
                                ...item,
                                Deleted: !item.Deleted,
                                __isChanged: true,
                            };
                        }
                        return item;
                    }),
                };
            } else {
                return {
                    ...prev,
                    [collectionKey]: [
                        { ...targetItem, __isAdded: true, __isChanged: true },
                        ...prev[collectionKey],
                    ],
                };
            }
        });
    };

    const modidyCollectionItem = <
        A extends PropertyCollectionActionType,
        K extends 'descriptions' | 'notes'
    >(
        collectionKey: K,
        action: A,
        item: A extends 'delete' ? { id: string } : PropertyState[K][number]
    ) => {
        setProperty(prev => {
            switch (action) {
                case 'delete':
                    if (parseInt(item.id) < 0) {
                        const current = prev[collectionKey] as Array<
                            PropertyState[K][number]
                        >;

                        return {
                            ...prev,
                            [collectionKey]: current.filter(
                                (desc: PropertyState[K][number]) =>
                                    desc.id !== item.id
                            ) as PropertyState[K],
                        };
                    } else {
                        return {
                            ...prev,
                            [collectionKey]: prev[collectionKey].map(desc =>
                                desc.id === item.id
                                    ? { ...desc, Deleted: true }
                                    : desc
                            ) as PropertyState[K],
                        };
                    }

                case 'add':
                    return {
                        ...prev,
                        [collectionKey]: [
                            {
                                ...(item as PropertyState[K][number]),
                                __isAdded: true,
                            },
                            ...prev[collectionKey],
                        ] as PropertyState[K],
                    };

                case 'update':
                    return {
                        ...prev,
                        [collectionKey]: prev[collectionKey].map(desc =>
                            desc.id === (item as PropertyState[K][number]).id
                                ? {
                                      ...(item as PropertyState[K][number]),
                                      __isChanged: true,
                                  }
                                : desc
                        ) as PropertyState[K],
                    };

                default:
                    return prev;
            }
        });
    };

    const handleResetLocation = () => {
        setProperty(prev => {
            return {
                ...prev,
                idRegion: 0,
                idProvince: 0,
                idCity: 0,
                postalCode: '',
            };
        });
    };

    const deleteStateRoom = (id: string) => {
        setProperty(prev => {
            const updatedRooms = prev.rooms.filter(room => room.id !== id);
            return { ...prev, rooms: updatedRooms };
        });
    };

    const addNewRoom = (room: RoomState) => {
        setProperty(prev => ({
            ...prev,
            rooms: [...prev.rooms, room],
        }));
    };

    const handleSaveFinish = async () => {
        const newProgres = { ...progress, totalProgress: 100 };
        await handleSaveDDBBMainInfo(newProgres);
    };

    const [complementaryData, setComplementaryData] =
        useState<ComplementaryDataState>({
            countries: [],
            regions: [],
            provinces: [],
            cities: [],
            timeZones: [],
            hotelTypes: [],
            hotelCategories: [],
            hotelChains: [],
            currencies: [],
            hostSegments: [],
            mealPlanTypes: [],
            serviceCategories: [],
            serviceTypes: [],
            roomServiceCategories: [],
            roomServiceTypes: [],
            beds: [],
            hotelImagesTypes: [],
            languages: [],
            childrenAgeSegments: [],
        });

    const getMainInfoSectionData = async () => {
        try {
            const [
                countriesResult,
                timeZonesResult,
                hotelTypesResult,
                hotelCategoriesResult,
                hotelChainsResult,
                currenciesResult,
            ] = await Promise.allSettled([
                getCountries(),
                getTimezones(),
                getHotelTypes(),
                getHotelCategories(),
                getHotelChains(),
                getCurrencies(),
            ]);

            const hasError =
                countriesResult.status === 'rejected' ||
                timeZonesResult.status === 'rejected' ||
                hotelTypesResult.status === 'rejected' ||
                hotelCategoriesResult.status === 'rejected' ||
                hotelChainsResult.status === 'rejected' ||
                currenciesResult.status === 'rejected';

            if (hasError) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
                return;
            }

            setComplementaryData(prev => ({
                ...prev,
                countries: countriesResult.value,
                timeZones: timeZonesResult.value,
                hotelTypes: hotelTypesResult.value,
                hotelCategories: hotelCategoriesResult.value,
                hotelChains: hotelChainsResult.value,
                currencies: currenciesResult.value,
            }));
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        }
    };

    const getLocationComplementaryData = async (idCountry: number) => {
        try {
            const [regionsResult, provincesResult, citiesResult] =
                await Promise.allSettled([
                    getRegions(idCountry),
                    getProvinces(idCountry),
                    getCities(idCountry),
                ]);

            const hasError =
                regionsResult.status === 'rejected' ||
                provincesResult.status === 'rejected' ||
                citiesResult.status === 'rejected';

            if (hasError) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
                return;
            }

            setComplementaryData(prev => ({
                ...prev,
                regions: regionsResult.value,
                provinces: provincesResult.value,
                cities: citiesResult.value,
            }));
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        }
    };

    useEffect(() => {
        if (property.idCountry) {
            getLocationComplementaryData(property.idCountry);
        }
    }, [property.idCountry]);

    const getDescriptionSectionData = async () => {
        try {
            const [
                serviceCategoriesResult,
                serviceTypesResult,
                imageTypesResult,
                hostSegmentsResult,
                mealPlanTypesResult,
                languagesResult,
                childrenAgeSegmentsResult,
            ] = await Promise.allSettled([
                getServiceCategories(),
                getServiceTypes(),
                getImageTypes(),
                getHostSegments(),
                getMealPlanTypes(),
                getDescriptionLanguages(),
                getChildrenAgeSegments(),
            ]);

            const hasError =
                serviceCategoriesResult.status === 'rejected' ||
                serviceTypesResult.status === 'rejected' ||
                imageTypesResult.status === 'rejected' ||
                hostSegmentsResult.status === 'rejected' ||
                mealPlanTypesResult.status === 'rejected' ||
                languagesResult.status === 'rejected' ||
                childrenAgeSegmentsResult.status === 'rejected';

            if (hasError) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
                return;
            }

            setComplementaryData(prev => ({
                ...prev,
                serviceCategories: serviceCategoriesResult.value.filter(
                    (category: { id: string }) => {
                        return serviceTypesResult.value.some(
                            (type: { idServiceCategory: number }) => {
                                return (
                                    type.idServiceCategory ===
                                    parseInt(category.id)
                                );
                            }
                        );
                    }
                ),
                serviceTypes: serviceTypesResult.value,
                hotelImagesTypes: imageTypesResult.value,
                hostSegments: hostSegmentsResult.value,
                mealPlanTypes: mealPlanTypesResult.value,
                languages: languagesResult.value,
                childrenAgeSegments: childrenAgeSegmentsResult.value,
            }));
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        }
    };

    const getRoomsSectionData = async () => {
        try {
            const [
                bedTypesResult,
                serviceCategoriesResult,
                serviceTypesResult,
                imageTypesResult,
                languagesResult,
            ] = await Promise.allSettled([
                getBedTypes(),
                getRoomServiceCategories(),
                getRoomServiceTypes(),
                getImageTypes(),
                getDescriptionLanguages(),
            ]);

            const hasError =
                bedTypesResult.status === 'rejected' ||
                serviceCategoriesResult.status === 'rejected' ||
                imageTypesResult.status === 'rejected' ||
                serviceTypesResult.status === 'rejected' ||
                languagesResult.status === 'rejected';

            if (hasError) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
                return;
            }

            setComplementaryData(prev => ({
                ...prev,
                beds: bedTypesResult.value,
                roomServiceCategories: serviceCategoriesResult.value.filter(
                    (category: { id: string }) => {
                        return serviceTypesResult.value.some(
                            (type: { idServiceCategory: number }) => {
                                return (
                                    type.idServiceCategory ===
                                    parseInt(category.id)
                                );
                            }
                        );
                    }
                ),
                roomServiceTypes: serviceTypesResult.value,
                hotelImagesTypes: imageTypesResult.value,
                languages: languagesResult.value,
            }));
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        }
    };

    const getZitoneoServicesData = async () => {
        try {
            const [serviceCategoriesResult, serviceTypesResult] =
                await Promise.allSettled([
                    getServiceCategories(),
                    getServiceTypes(),
                ]);

            const hasError =
                serviceCategoriesResult.status === 'rejected' ||
                serviceTypesResult.status === 'rejected';
            if (hasError) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
                return;
            }

            setComplementaryData(prev => ({
                ...prev,
                serviceCategories: serviceCategoriesResult.value.filter(
                    (category: { id: string }) => {
                        return serviceTypesResult.value.some(
                            (type: { idServiceCategory: number }) => {
                                return (
                                    type.idServiceCategory ===
                                    parseInt(category.id)
                                );
                            }
                        );
                    }
                ),
                serviceTypes: serviceTypesResult.value,
            }));
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            console.error(error);
        }
    };

    const [descriptionDetail, setDescriptionDetail] =
        useState<DescriptionDetailState>(DESCRIPTION_DEATIL_INITIAL_STATE);

    const handleDescriptionDetailChange = (
        newValue: Partial<DescriptionDetailState>
    ) => {
        setDescriptionDetail(prev => ({
            ...prev,
            ...newValue,
        }));
    };

    const {
        isLoadingAssistant,
        askQuestion,
        answer,
        assistantError,
        resetAssistant,
    } = useDataAssistant(PROMPT_KEYS.HOTEL_DESCRIPTION);

    const getAIDescription = async (lang: string) => {
        const parameters = {
            hotel: property.name,
            language: lang,
        };
        const question = '';
        await askQuestion(question, parameters);
    };

    const [noteDetail, setNoteDetail] = useState<NoteDetailState>(
        NOTE_DETAIL_INITIAL_STATE
    );

    const handleNoteDetailChange = (newValue: Partial<NoteDetailState>) => {
        setNoteDetail(prev => ({
            ...prev,
            ...newValue,
        }));
    };

    const [imagesDetail, setImagesDetail] = useState<ImagesDetailState>(
        IMAGES_DETAIL_INITIAL_STATE
    );

    const togglePanelOpen = (isOpen: boolean) => {
        setImagesDetail(prev => {
            return {
                ...prev,
                isOpenPanel: isOpen,
            };
        });
    };

    const addImagesToDetail = (images: ImageState[]) => {
        setImagesDetail(prev => {
            return {
                ...prev,
                images: [...images, ...prev.images],
            };
        });
    };

    const deleteImagesFromDetail = (id?: string) => {
        setImagesDetail(prev => {
            const updatedImages = id
                ? prev.images.filter(image => image.id !== id)
                : [];
            return {
                ...prev,
                images: updatedImages,
            };
        });
    };

    const setImagesDetailCategory = (
        category: ComplementaryImageTypeState | null
    ) => {
        setImagesDetail(prev => {
            return {
                ...prev,
                category,
            };
        });
    };

    const setAddImageDetail = (
        category: ComplementaryImageTypeState | null
    ) => {
        setImagesDetail(prev => {
            return {
                ...prev,
                images: [],
                isOpenPanel: true,
                isDropdownVisible: true,
                category,
                idRoom: 0,
            };
        });
    };

    const setAddRoomImageDetail = () => {
        const category = complementaryData.hotelImagesTypes.find(
            imageType => imageType.nameKey === BEDROOM_IMAGE_TYPE_KEY
        );
        setImagesDetail(() => {
            return {
                isLoading: false,
                images: [],
                isOpenPanel: true,
                isDropdownVisible: false,
                category: category,
                idRoom: parseInt(roomDetail),
            };
        });
    };

    const resetImageDatailData = () => {
        setImagesDetail(IMAGES_DETAIL_INITIAL_STATE);
    };

    const toggleFeaturedImage = (id: string, bool: boolean) => {
        setProperty(prev => {
            return {
                ...prev,
                images: prev.images.map(image => {
                    if (image.id === id) {
                        return { ...image, feature: bool, __isChanged: true };
                    }
                    return { ...image, feature: false, __isChanged: true };
                }),
            };
        });
    };

    const toggleImage360 = (id: string) => {
        setProperty(prev => {
            return {
                ...prev,
                images: prev.images.map(image => {
                    if (image.id === id) {
                        return {
                            ...image,
                            is360: !image.is360,
                            __isChanged: true,
                        };
                    }
                    return { ...image };
                }),
            };
        });
    };

    const handleDeleteImage = async (idImg: string) => {
        const objToSend = {
            IdHotel: property.idHotel,
            IdSupplierHotel: property.id,
            IdSupplierHotelRoomType: roomDetail ? parseInt(roomDetail) : 0,
            IdFile: parseInt(idImg),
        };
        setIsFetching(true);
        try {
            const { data } = await api.post(
                endpoints.removeSupplierHotelImages,
                convertToOvariant(null, objToSend)
            );
            if (data.Success) {
                setSuccessMessage(FeedbackMessages.COMMON_SUCCESS_DELETE);
                setProperty(prev => {
                    return {
                        ...prev,
                        images: prev.images.filter(image => image.id !== idImg),
                        rooms: prev.rooms.map(room => {
                            if (room.id === roomDetail) {
                                return {
                                    ...room,
                                    images: room.images.filter(
                                        image => image.id !== idImg
                                    ),
                                };
                            }
                            return room;
                        }),
                    };
                });
            }
        } catch (error) {
            console.log(error);
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            setIsFetching(false);
        }
    };

    const saveDetailImagesToDDBB = async () => {
        try {
            setImagesDetail(prev => {
                return {
                    ...prev,
                    isLoading: true,
                };
            });
            const uploadEndPoint = endpoints.addImages(
                property.id,
                imagesDetail.category?.id || '',
                imagesDetail.idRoom
            );
            const filesToUpload = new FormData();
            imagesDetail.images.forEach(image => {
                if (image.file) {
                    filesToUpload.append('', image.file);
                }
            });
            setIsFetching(true);

            const { data } = await api.post(uploadEndPoint, filesToUpload);
            if (
                data.Success &&
                data.Result &&
                data.Result.files &&
                data.Result.files.length
            ) {
                setSuccessMessage(FeedbackMessages.COMMON_SUCCESS_CREATE);
                setProperty(prev => {
                    return {
                        ...prev,
                        images: [
                            ...data.Result.files.map(
                                (image: {
                                    Id: string;
                                    Caption: string;
                                    Feature: boolean;
                                    Is360: boolean;
                                    IdHotelImageType: number;
                                    HotelImageType: { Key: string };
                                    VirtualPath: string;
                                    IdSupplierHotelRoomType: number;
                                }) => ({
                                    id: image.Id,
                                    caption: image.Caption,
                                    feature: image.Feature,
                                    is360: image.Is360,
                                    idType: image.IdHotelImageType,
                                    type: image.HotelImageType.Key || '',
                                    url: image.VirtualPath || '',
                                    idRoom: image.IdSupplierHotelRoomType,
                                    __isAdded: true,
                                    __isChanged: true,
                                })
                            ),
                            ...prev.images,
                        ],
                        rooms: prev.rooms.map(room => {
                            if (parseInt(room.id) === imagesDetail.idRoom) {
                                return {
                                    ...room,
                                    images: [
                                        ...room.images,
                                        ...data.Result.files.map(
                                            (image: {
                                                Id: string;
                                                Caption: string;
                                                Feature: boolean;
                                                Is360: boolean;
                                                IdHotelImageType: number;
                                                HotelImageType: { Key: string };
                                                VirtualPath: string;
                                                IdSupplierHotelRoomType: number;
                                            }) => ({
                                                id: image.Id,
                                                caption: image.Caption,
                                                feature: image.Feature,
                                                is360: image.Is360,
                                                idType: image.IdHotelImageType,
                                                type:
                                                    image.HotelImageType.Key ||
                                                    '',
                                                url: image.VirtualPath || '',
                                                idRoom: image.IdSupplierHotelRoomType,
                                                __isAdded: true,
                                                __isChanged: true,
                                            })
                                        ),
                                    ],
                                };
                            }
                            return room;
                        }),
                    };
                });
                setImagesDetail(IMAGES_DETAIL_INITIAL_STATE);
            }
            if (data.Result.failed.length) {
                setErrorMessage(data.Result.failed[0]);
            }
        } catch (error) {
            console.error(error);
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            setIsFetching(false);
        }
    };

    const handleSaveDDBBMainInfo = async (
        newProgress: ProgressState = progress
    ) => {
        try {
            setIsFetching(true);
            const dataToSend = adaptPropertyStateToDDBB(property, newProgress);
            const objectBase64 = convertToOvariant(
                savableEntities.SupplierHotel,
                dataToSend,
                property.id,
                supplierHotelViewModelModel
            );

            const { data } = await api.post(
                endpoints.saveSupplierHotelFromWizard,
                objectBase64
            );
            if (data.Success) {
                setSuccessMessage(FeedbackMessages.COMMON_SUCCESS_UPDATE);
                const stateProperty = adaptDDBBToPropertyState(data.Result);
                setProperty(stateProperty);
                // if the booking and accounting email/phone have not been set, we assume that the contact info is the same as the general email/phone
                setIsDifferentContactInfo(
                    getIsDifferentContactInfo(stateProperty)
                );
                setProgress(prev => {
                    return {
                        ...prev,
                        ...adaptDDBBToProgressState(data.Result),
                    };
                });
            }
            if (!data.Success && data.Messages && data.Messages.length) {
                setErrorMessage(data.Messages[0]?.Title);
                return;
            }
        } catch (error) {
            console.log(error);
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            setIsFetching(false);
        }
    };

    const handleSaveRoomsToDDBB = async () => {
        const roomToSave = property.rooms.find(room => room.id === roomDetail);

        if (!roomToSave) return;

        const objectToSend = convertToOvariant(
            savableEntities.SupplierHotelRoomType,
            adaptRoomToDDBB(roomToSave),
            roomDetail,
            supplierRoomViewModelModel
        );

        try {
            const res = await api.post(endpoints.commonSave, objectToSend);
            if (res.data) {
                setProperty(prev => {
                    return {
                        ...prev,
                        rooms: prev.rooms.map(room => {
                            if (room.id === roomDetail) {
                                return adaptRoomDDBBToState(res.data);
                            }
                            return room;
                        }),
                    };
                });
                setSuccessMessage(FeedbackMessages.COMMON_SUCCESS_UPDATE);
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            console.error(error);
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        }
    };

    const [roomDetail, setRoomDetail] = useState('');

    const handleTargetRoom = (id?: string) => {
        const targetRoom = id
            ? property.rooms.find(room => room.id === id)
            : undefined;

        setRoomDetail(targetRoom && id ? id : '');
    };

    const handleRoomInputChange = (name: string, value: string | number) => {
        setProperty(prev => {
            return {
                ...prev,
                rooms: prev.rooms.map(room => {
                    if (room.id === roomDetail) {
                        return {
                            ...room,
                            [name]: value,
                            __isChanged: true,
                        };
                    }
                    return room;
                }),
            };
        });
    };

    const toggleRoomItemInCollection = (
        collectionKey: 'services' | 'bedTypes',
        targetItem: ServiceState
    ) => {
        // simple collections => segments, services...
        setProperty(prev => {
            return {
                ...prev,
                rooms: prev.rooms.map(room => {
                    if (room.id === roomDetail) {
                        const itemExists = room[collectionKey].some(
                            item => item.id === targetItem.id
                        );

                        if (itemExists) {
                            // if the item exists, handle with deleted true/false
                            return {
                                ...room,
                                [collectionKey]: room[collectionKey].map(
                                    item => {
                                        if (item.id === targetItem.id) {
                                            return {
                                                ...item,
                                                Deleted: !item.Deleted,
                                                __isChanged: true,
                                            };
                                        }
                                        return item;
                                    }
                                ),
                            };
                        } else {
                            return {
                                ...room,
                                [collectionKey]: [
                                    {
                                        ...targetItem,
                                        __isAdded: true,
                                        __isChanged: true,
                                    },
                                    ...room[collectionKey],
                                ],
                            };
                        }
                    }
                    return room;
                }),
            };
        });
    };

    const handleRoomDescription = (
        action: PropertyCollectionActionType,
        newRoomDescription: DescriptionState
    ) => {
        setProperty(prev => {
            return {
                ...prev,
                rooms: prev.rooms.map(room => {
                    if (room.id === roomDetail) {
                        const prevDescriptions = [...room.descriptions];
                        let newDescriptions: DescriptionState[] = [];

                        if (action === 'add') {
                            newDescriptions = [
                                {
                                    ...newRoomDescription,
                                    __isAdded: true,
                                    __isChanged: true,
                                },
                                ...prevDescriptions,
                            ];
                        } else {
                            newDescriptions = prevDescriptions.map(
                                description => {
                                    if (
                                        description.id === newRoomDescription.id
                                    ) {
                                        return {
                                            ...newRoomDescription,
                                            __isChanged: action === 'update',
                                            Deleted: action === 'delete',
                                        };
                                    }
                                    return description;
                                }
                            );
                        }
                        return {
                            ...room,
                            descriptions: newDescriptions,
                            __isChanged: true,
                        };
                    }
                    return room;
                }),
            };
        });
    };

    const toggleRoomImageIs360 = (idImg: string) => {
        setProperty(prev => {
            return {
                ...prev,
                rooms: prev.rooms.map(room => {
                    if (room.id === roomDetail) {
                        return {
                            ...room,
                            images: room.images.map(image => {
                                if (image.id === idImg) {
                                    return {
                                        ...image,
                                        is360: !image.is360,
                                        __isChanged: true,
                                    };
                                }
                                return image;
                            }),
                        };
                    }
                    return room;
                }),
            };
        });
    };

    const toggleRoomImageFeature = (idImg: string) => {
        setProperty(prev => {
            return {
                ...prev,
                rooms: prev.rooms.map(room => {
                    if (room.id === roomDetail) {
                        return {
                            ...room,
                            images: room.images.map(image => {
                                if (image.id === idImg) {
                                    return {
                                        ...image,
                                        feature: true,
                                        __isChanged: true,
                                    };
                                }
                                return {
                                    ...image,
                                    feature: false,
                                    __isChanged: true,
                                };
                            }),
                        };
                    }
                    return room;
                }),
                images: prev.images.map(image => {
                    if (image.id === idImg) {
                        return {
                            ...image,
                            feature: true,
                            __isChanged: true,
                        };
                    }
                    return {
                        ...image,
                        feature: false,
                        __isChanged: true,
                    };
                }),
            };
        });
    };

    const [isValidated, setIsValidated] = useState(false);
    const handleIsValidated = (bool: boolean) => {
        setIsValidated(bool);
    };

    const [propertyValidationErrors, setPropertyValidationErrors] =
        useState<ValidationErrorsState>(VALIDATIONERRORS_INITIAL_STATE);

    const handleValidation = (errors: Partial<ValidationErrorsState>) => {
        setPropertyValidationErrors({
            ...VALIDATIONERRORS_INITIAL_STATE,
            ...errors,
        });
    };

    const [presentationSelectedTab, setPresentationSelectedTab] =
        useState<PresentationTabNames>(PresentationTabNames.HOTEL);

    const changePresentationTab = (newValue: PresentationTabNames) => {
        setPresentationSelectedTab(newValue);
    };

    const addNewZitoneoService = async (
        zitoneoService: ZinantisServiceState
    ) => {
        const existingService = property.zitoneoServices.find(
            service =>
                service.idServiceType === zitoneoService.idServiceType &&
                service.idServiceCategory === zitoneoService.idServiceCategory
        );
        handleToggleVisibleServicesDetail(zitoneoService.idServiceType);
        if (existingService) {
            setProperty(prev => {
                return {
                    ...prev,
                    zitoneoServices: prev.zitoneoServices.map(service => {
                        const isTargetService =
                            service.idServiceType ===
                                zitoneoService.idServiceType &&
                            service.idServiceCategory ===
                                zitoneoService.idServiceCategory;
                        if (isTargetService) {
                            return {
                                ...service,
                                Deleted: false,
                                __isChanged: true,
                            };
                        }
                        return service;
                    }),
                };
            });
            return;
        }
        setProperty(prev => {
            return {
                ...prev,
                zitoneoServices: [
                    {
                        ...zitoneoService,
                        __isAdded: true,
                        Deleted: false,
                    },
                    ...prev.zitoneoServices,
                ],
            };
        });
        try {
            const { data } = await getServiceAttributeDefinitions(
                zitoneoService.idServiceType
            );
            if (data.Success && data.Result) {
                setProperty(prev => {
                    return {
                        ...prev,
                        zitoneoServices: prev.zitoneoServices.map(service => {
                            const isTargetService =
                                service.idServiceType ===
                                    zitoneoService.idServiceType &&
                                service.idServiceCategory ===
                                    zitoneoService.idServiceCategory;
                            if (isTargetService) {
                                return {
                                    ...service,
                                    attributeDefinitions:
                                        data.Result?.AttributeDefinitionEntities.map(
                                            attrDef =>
                                                adaptDDBBAttributeDefinitionToState(
                                                    attrDef
                                                )
                                        ) || [],

                                    attributeValues:
                                        adaptDDBBAttributeValuesAndCreateNewOnesToState(
                                            [],
                                            data.Result
                                                ?.AttributeDefinitionEntities ||
                                                []
                                        ),
                                    __isChanged: true,
                                };
                            }
                            return service;
                        }),
                    };
                });
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        }
    };
    const toggleZitoneoService = async (
        zitoneoService: ZinantisServiceState
    ) => {
        const existingService = property.zitoneoServices.find(
            service =>
                service.idServiceType === zitoneoService.idServiceType &&
                service.idServiceCategory === zitoneoService.idServiceCategory
        );

        if (!existingService) {
            await addNewZitoneoService(zitoneoService);
            return;
        }

        setProperty(prev => {
            return {
                ...prev,
                zitoneoServices: prev.zitoneoServices.map(service => {
                    const isTargetService =
                        service.idServiceType ===
                            zitoneoService.idServiceType &&
                        service.idServiceCategory ===
                            zitoneoService.idServiceCategory;

                    if (!isTargetService) {
                        return service;
                    }

                    return {
                        ...service,
                        Deleted: !service.Deleted,
                        __isChanged: true,
                    };
                }),
            };
        });
    };

    const [visibleIdServicesDetail, setVisibleIdServicesDetail] =
        useState<number>(0);

    const handleToggleVisibleServicesDetail = (idServiceType?: number) => {
        setVisibleIdServicesDetail(prev => {
            if (prev === idServiceType) {
                return 0;
            } else {
                return idServiceType || 0;
            }
        });
    };

    const handleChangeZitoneoServiceValue = (
        id: string,
        value: string | boolean | Date | number | null,
        idService: string,
        idAttributeDefinition: number
    ) => {
        const parsedIdService = parseInt(idService);
        setProperty(prev => {
            return {
                ...prev,
                zitoneoServices: prev.zitoneoServices.map(service => {
                    if (service.idServiceType === parsedIdService) {
                        const currentAttributeValues =
                            service.attributeValues || [];
                        const attributeValueExists =
                            currentAttributeValues.some(
                                attrValue => attrValue.id === id
                            );

                        const updatedAttributeValues = attributeValueExists
                            ? currentAttributeValues.map(attrValue => {
                                  if (attrValue.id === id) {
                                      return {
                                          ...attrValue,
                                          value,
                                          __isChanged: true,
                                      };
                                  }

                                  return attrValue;
                              })
                            : [
                                  ...currentAttributeValues,
                                  {
                                      id,
                                      idAttributeDefinition,
                                      value,
                                      __isAdded: true,
                                      __isChanged: true,
                                  },
                              ];

                        return {
                            ...service,
                            attributeValues: updatedAttributeValues,
                            __isChanged: true,
                        };
                    }
                    return service;
                }),
            };
        });
    };

    const handleRemoveZitoneoServiceValue = (
        id: string,
        idService: string,
        idAttributeDefinition: number
    ) => {
        const parsedIdService = parseInt(idService);

        setProperty(prev => {
            return {
                ...prev,
                zitoneoServices: prev.zitoneoServices.map(service => {
                    if (service.idServiceType !== parsedIdService) {
                        return service;
                    }

                    const currentAttributeValues =
                        service.attributeValues || [];
                    const updatedAttributeValues =
                        currentAttributeValues.filter(
                            attrValue =>
                                !(
                                    attrValue.id === id &&
                                    attrValue.idAttributeDefinition ===
                                        idAttributeDefinition
                                )
                        );

                    return {
                        ...service,
                        attributeValues: updatedAttributeValues,
                        __isChanged: true,
                    };
                }),
            };
        });
    };

    const handlePropertyAttributeValueChange = (
        id: string,
        idAttributeDefinition: number,
        value: string | boolean | Date | number | null
    ) => {
        const attributeValueExists = property.attributeValues?.some(
            attr =>
                attr.id === id &&
                attr.idAttributeDefinition === idAttributeDefinition
        );

        setProperty(prev => {
            return {
                ...prev,
                attributeValues: attributeValueExists
                    ? prev.attributeValues.map(attr => {
                          if (
                              attr.id === id &&
                              attr.idAttributeDefinition ===
                                  idAttributeDefinition
                          ) {
                              return {
                                  ...attr,
                                  value,
                                  __isChanged: true,
                              };
                          }
                          return attr;
                      })
                    : [
                          ...(prev.attributeValues || []),
                          {
                              id,
                              idAttributeDefinition,
                              value,
                              __isAdded: true,
                              __isChanged: true,
                          },
                      ],
            };
        });
    };

    const handleDeleteHotelAttributeValue = (
        id: string,
        idAttributeDefinition: number
    ) => {
        setProperty(prev => {
            return {
                ...prev,
                attributeValues: prev.attributeValues?.map(attr => {
                    if (
                        attr.id === id &&
                        attr.idAttributeDefinition === idAttributeDefinition
                    ) {
                        return {
                            ...attr,
                            Deleted: true,
                            __isChanged: true,
                        };
                    }
                    return attr;
                }),
            };
        });
    };

    return (
        <PropertyContext.Provider
            value={{
                isFetching,
                handleFetching,
                property,
                progress,
                handleInputChange,
                updateChildrenAgeSegmentAge,
                addChildrenAgeSegment,
                deleteChildrenAgeSegment,
                deleteStateRoom,
                handleProgress,
                handleForwardProgress,
                complementaryData,
                getDescriptionSectionData,
                isDifferentContactInfo,
                handleIsDifferentContactInfo,
                handleResetLocation,
                toggleItemInCollection,
                modidyCollectionItem,
                descriptionDetail,
                handleDescriptionDetailChange,
                getAIDescription,
                isLoadingAIDescriptionAssistant: isLoadingAssistant,
                AIDescriptionAnswer: answer,
                AIDescriptionError: assistantError,
                resetAIDescriptionAssistant: resetAssistant,
                noteDetail,
                handleNoteDetailChange,
                imagesDetail,
                togglePanelOpen,
                addImagesToDetail,
                deleteImagesFromDetail,
                handleSaveDDBBMainInfo,
                handleSaveFinish,
                handleSaveRoomsToDDBB,
                roomDetail,
                handleTargetRoom,
                getMainInfoSectionData,
                getRoomsSectionData,
                handleRoomInputChange,
                toggleRoomItemInCollection,
                propertyValidationErrors,
                handleValidation,
                isValidated,
                handleIsValidated,
                toggleFeaturedImage,
                toggleImage360,
                handleDeleteImage,
                setImagesDetailCategory,
                setAddRoomImageDetail,
                setAddImageDetail,
                resetImageDatailData,
                saveDetailImagesToDDBB,
                toggleRoomImageIs360,
                toggleRoomImageFeature,
                addNewRoom,
                handleRoomDescription,
                presentationSelectedTab,
                changePresentationTab,
                getZitoneoServicesData,
                addNewZitoneoService,
                toggleZitoneoService,
                visibleIdServicesDetail,
                handleToggleVisibleServicesDetail,
                handleChangeZitoneoServiceValue,
                handleRemoveZitoneoServiceValue,
                handlePropertyAttributeValueChange,
                handleDeleteHotelAttributeValue,
            }}
        >
            {children}
        </PropertyContext.Provider>
    );
};

export const usePropertyFetching = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyFetching must be used within a PropertyProvider'
        );
    }
    const { isFetching, handleFetching } = context;
    return { isFetching, handleFetching };
};

export const useProperty = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyContext must be used within a PropertyProvider'
        );
    }
    const {
        property,
        handleInputChange,
        updateChildrenAgeSegmentAge,
        addChildrenAgeSegment,
        deleteChildrenAgeSegment,
        isDifferentContactInfo,
        handleIsDifferentContactInfo,
        handleResetLocation,
        toggleItemInCollection,
        modidyCollectionItem,
        toggleFeaturedImage,
        toggleImage360,
        handleDeleteImage,
    } = context;
    return {
        ...property,
        handleInputChange,
        updateChildrenAgeSegmentAge,
        addChildrenAgeSegment,
        deleteChildrenAgeSegment,
        isDifferentContactInfo,
        handleIsDifferentContactInfo,
        handleResetLocation,
        toggleItemInCollection,
        modidyCollectionItem,
        toggleFeaturedImage,
        toggleImage360,
        handleDeleteImage,
    };
};

export const usePropertyPresentation = () => {
    const language = useLanguage();
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyPresentation must be used within a PropertyProvider'
        );
    }
    const {
        property,
        deleteStateRoom,
        presentationSelectedTab,
        changePresentationTab,
    } = context;
    const {
        name,
        hotelCategory,
        rating,
        address,
        phone,
        email,
        descriptions,
        services,
        hostSegments,
        mealPlanTypes,
        images: allImages,
        rooms,
        id,
        taxes,
        supplements,
        stopSales,
    } = property;

    const description = useMemo(() => {
        return getVisibleDescription(descriptions, language);
    }, [descriptions, language]);

    const presentationImages = useMemo(() => {
        return allImages
            .sort((a, b) => (a.feature === b.feature ? 0 : a.feature ? -1 : 1))
            .slice(0, 4);
    }, [allImages]);

    return {
        name,
        hotelCategory,
        rating,
        address,
        phone,
        email,
        description,
        services,
        hostSegments,
        mealPlanTypes,
        images: presentationImages,
        rooms,
        idSupplierHotel: id,
        id,
        deleteStateRoom,
        taxes,
        supplements,
        stopSales,
        presentationSelectedTab,
        changePresentationTab,
    };
};

export const usePropertyProgress = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyContext must be used within a PropertyProvider'
        );
    }
    const { progress, handleProgress, handleForwardProgress } = context;
    return { ...progress, handleProgress, handleForwardProgress };
};

export const usePropertyComplementaryData = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyComplementaryData must be used within a PropertyProvider'
        );
    }

    const {
        complementaryData,
        getMainInfoSectionData,
        getDescriptionSectionData,
        getRoomsSectionData,
    } = context;

    const {
        countries,
        regions,
        provinces,
        cities,
        timeZones,
        hotelTypes,
        hotelCategories,
        hotelChains,
        currencies,
        hostSegments,
        mealPlanTypes,
        serviceCategories,
        serviceTypes,
        hotelImagesTypes,
        languages,
        beds,
        roomServiceCategories,
        roomServiceTypes,
        childrenAgeSegments,
    } = complementaryData;

    return {
        countriesList: countries,
        regionsList: regions,
        provincesList: provinces,
        citiesList: cities,
        timeZonesList: timeZones,
        hotelTypesList: hotelTypes,
        hotelCategoriesList: hotelCategories,
        hotelChainsList: hotelChains,
        currenciesList: currencies,
        hostSegmentsList: hostSegments,
        mealPlanTypesList: mealPlanTypes,
        serviceCategoriesList: serviceCategories,
        serviceTypesList: serviceTypes,
        hotelImagesTypeList: hotelImagesTypes,
        languagesList: languages,
        bedsList: beds,
        roomServiceCategoriesList: roomServiceCategories,
        roomServiceTypesList: roomServiceTypes,
        childrenAgeSegmentsList: childrenAgeSegments,
        getDescriptionSectionData,
        getRoomsSectionData,
        getMainInfoSectionData,
    };
};

export const usePropertyDescriptionDetail = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyDescriptionDetail must be used within a PropertyProvider'
        );
    }

    const {
        descriptionDetail,
        handleDescriptionDetailChange,
        getAIDescription,
        isLoadingAIDescriptionAssistant,
        AIDescriptionAnswer,
        AIDescriptionError,
        resetAIDescriptionAssistant,
    } = context;

    return {
        ...descriptionDetail,
        handleDescriptionDetailChange,
        getAIDescription,
        isLoadingAIDescriptionAssistant,
        AIDescriptionAnswer,
        AIDescriptionError,
        resetAIDescriptionAssistant,
    };
};

export const usePropertyRoomDescriptionDetail = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyDescriptionDetail must be used within a PropertyProvider'
        );
    }

    const {
        descriptionDetail,
        handleDescriptionDetailChange,
        handleRoomDescription,
    } = context;
    return {
        ...descriptionDetail,
        handleDescriptionDetailChange,
        handleRoomDescription,
    };
};

export const usePropertyImagesDetail = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyImageDetail must be used within a PropertyProvider'
        );
    }

    const {
        imagesDetail,
        togglePanelOpen,
        addImagesToDetail,
        deleteImagesFromDetail,
        setImagesDetailCategory,
        setAddRoomImageDetail,
        setAddImageDetail,
        resetImageDatailData,
        saveDetailImagesToDDBB,
    } = context;

    return {
        ...imagesDetail,
        togglePanelOpen,
        addImagesToDetail,
        deleteImagesFromDetail,
        setImagesDetailCategory,
        setAddRoomImageDetail,
        setAddImageDetail,
        resetImageDatailData,
        saveDetailImagesToDDBB,
    };
};

export const useNoteDetail = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error('useNoteDetail must be used within a PropertyProvider');
    }

    const { noteDetail, handleNoteDetailChange } = context;

    return {
        ...noteDetail,
        handleNoteDetailChange,
    };
};

export const usePropertyRoomDetail = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyRoomDetail must be used within a PropertyProvider'
        );
    }
    const {
        property,
        roomDetail,
        handleRoomInputChange,
        toggleRoomItemInCollection,
        handleTargetRoom,
        toggleRoomImageIs360,
        toggleRoomImageFeature,
        addNewRoom,
        handleDescriptionDetailChange,
        handleRoomDescription,
    } = context;

    const targetRoom = useMemo(() => {
        return (
            property.rooms.find(room => room.id === roomDetail) ||
            ROOM_INITIAL_STATE
        );
    }, [property.rooms, roomDetail]);

    return {
        ...targetRoom,
        handleRoomInputChange,
        toggleRoomItemInCollection,
        handleTargetRoom,
        toggleRoomImageIs360,
        toggleRoomImageFeature,
        roomsLoaded: property.rooms.length > 0,
        addNewRoom,
        handleDescriptionDetailChange,
        handleRoomDescription,
    };
};

export const usePropertySaving = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertySaving must be used within a PropertyProvider'
        );
    }
    const {
        handleSaveDDBBMainInfo,
        handleSaveRoomsToDDBB,
        progress,
        handleSaveFinish,
    } = context;

    const handleSave = async (newProgress: ProgressState = progress) => {
        if (newProgress.activeStep === PROGRESS_STEP.ROOM_CONFIGURATION) {
            await handleSaveRoomsToDDBB();
        }
        await handleSaveDDBBMainInfo(newProgress);
    };
    return {
        handleSaveDDBBMainInfo,
        handleSaveRoomsToDDBB,
        handleSave,
        handleSaveFinish,
    };
};

export const usePropertyValidation = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'usePropertyValidation must be used within a PropertyProvider'
        );
    }

    const {
        property,
        propertyValidationErrors,
        handleValidation,
        isValidated,
        handleIsValidated,
        roomDetail,
    } = context;

    const targetRoom = property.rooms.find(room => room.id === roomDetail);

    const fieldsToValidate = {
        [PROGRESS_MAIN_INFORMATION_TAB.COMMERCIAL]: {
            name: {
                value: property.name,
                validators: ['requiredString'],
            },
        },
        [PROGRESS_MAIN_INFORMATION_TAB.CONTACT]: {
            phone: {
                value: property.phone,
                validators: ['phone'],
            },
            email: {
                value: property.email,
                validators: ['email'],
            },
        },
        [PROGRESS_MAIN_INFORMATION_TAB.LOCATION]: {
            address: {
                value: property.address,
                validators: ['requiredString'],
            },
            idCountry: {
                value: property.idCountry,
                validators: ['requiredIdEntity'],
            },
            idCity: {
                value: property.idCity,
                validators: ['requiredIdEntity'],
            },
            postalCode: {
                value: property.postalCode,
                validators: ['requiredString'],
            },
        },
        [PROGRESS_MAIN_INFORMATION_TAB.AREA]: {
            idTimeZone: {
                value: property.idTimeZone,
                validators: ['requiredIdEntity'],
            },
        },
        [PROGRESS_MAIN_INFORMATION_TAB.PROPERTY]: {
            idHotelType: {
                value: property.idHotelType,
                validators: ['requiredIdEntity'],
            },
            idHotelCategory: {
                value: property.idHotelCategory,
                validators: ['requiredIdEntity'],
            },
            roomCount: {
                value: property.roomCount,
                validators: ['requiredNumber'],
            },
            idCurrency: {
                value: property.idCurrency,
                validators: ['requiredIdEntity'],
            },
        },
        [PROGRESS_PUBLIC_PORTRAIT_TAB.KID_POLICIES]: {
            childrenAgeSegments: {
                value: {
                    adultAge: property.adultAge,
                    adultsOnly: property.adultsOnly,
                    segments: property.childrenAgeSegments
                        .filter(segment => !segment.Deleted)
                        .sort(
                            (first, second) =>
                                getChildrenAgeSegmentSortOrder(first) -
                                    getChildrenAgeSegmentSortOrder(second) ||
                                first.name.localeCompare(second.name)
                        ),
                },
                validators: ['validChildrenAgeRanges'],
            },
        },
        [PROGRESS_ROOM_CONFIGURATION_TAB.OCCUPANCY]: {
            standardOccupancy: {
                value: targetRoom?.standardOccupancy,
                validators: ['requiredNumber'],
            },
            minAdults: {
                value: targetRoom?.minAdults,
                validators: ['requiredNumber'],
            },
            maxAdults: {
                value: {
                    maxAdults: targetRoom?.maxAdults,
                    minAdults: targetRoom?.minAdults,
                    standardOccupancy: targetRoom?.standardOccupancy,
                },
                validators: ['customMaxAdults'],
            },
            maxChildren: {
                value: {
                    maxChildren: targetRoom?.maxChildren,
                    minChildren: targetRoom?.minChildren,
                    adultsOnly: targetRoom?.adultsOnly,
                },
                validators: ['customMaxChildren'],
            },
        },
    };

    const handleValidate = (sectionKey: string) => {
        const sectionFields =
            fieldsToValidate[sectionKey as keyof typeof fieldsToValidate] || {};

        const validationErrors: {
            inputKey: string;
            errorMessage: string;
        }[] = validateForm(sectionFields);
        const newErrors: Record<string, string> = {};
        for (const newError of validationErrors) {
            newErrors[newError.inputKey] = newError.errorMessage;
        }
        handleValidation(newErrors);
        return validationErrors.length === 0;
    };

    return {
        errors: propertyValidationErrors,
        handleValidate,
        isValidated,
        handleIsValidated,
    };
};

export const useZitoneoComplementaryData = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'useZitoneoComplementaryData must be used within a PropertyProvider'
        );
    }

    const { complementaryData, getZitoneoServicesData } = context;

    const { serviceCategories, serviceTypes } = complementaryData;

    return {
        serviceCategoriesList: serviceCategories,
        serviceTypesList: serviceTypes,
        getZitoneoServicesData,
    };
};

export const useZitoneoHotelServices = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'useZitoneoHotelServices must be used within a PropertyProvider'
        );
    }
    const {
        property,
        addNewZitoneoService,
        toggleZitoneoService,
        visibleIdServicesDetail,
        handleToggleVisibleServicesDetail,
        handleChangeZitoneoServiceValue,
        handleRemoveZitoneoServiceValue,
    } = context;
    const { zitoneoServices } = property;
    return {
        zitoneoServices:
            zitoneoServices.filter(service => !service.Deleted) || [],
        addNewZitoneoService,
        toggleZitoneoService,
        visibleIdServicesDetail,
        handleToggleVisibleServicesDetail,
        handleChangeZitoneoServiceValue,
        handleRemoveZitoneoServiceValue,
    };
};

export const useZitoneoHotelAttributes = () => {
    const context = useContext(PropertyContext);
    if (context === undefined) {
        throw new Error(
            'useZitoneoHotelAttributes must be used within a PropertyProvider'
        );
    }
    const {
        property,
        handlePropertyAttributeValueChange,
        handleDeleteHotelAttributeValue,
    } = context;
    const { attributeDefinitions, attributeValues } = property;
    return {
        attributeDefinitions: attributeDefinitions || [],
        attributeValues: attributeValues.filter(value => !value.Deleted) || [],
        handlePropertyAttributeValueChange,
        handleDeleteHotelAttributeValue,
    };
};
